"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keyPair_1 = require("./keyPair");
exports.KeyPair = keyPair_1.default;
var hexToBuff = function (text) { return Buffer.from(text, 'hex'); };
exports.hexToBuff = hexToBuff;
var buffToHex = function (buff) { return buff.toString('hex'); };
exports.buffToHex = buffToHex;
//# sourceMappingURL=index.js.map